
import axios from 'axios';

const custom_api_func = axios.create({
    baseURL: 'https://api.successguardian.in/',
    withCredentials: true
});

custom_api_func.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;

        // Prevent retry loop and avoid intercepting token refresh request
        if (
            error.response &&
            (error.response.status === 401) &&
            !originalRequest._retry &&
            !originalRequest.url.includes('api/access-token-refresh/')
        ) {
            originalRequest._retry = true;

            try {
                console.log('xxx', 'here 1');
                await custom_api_func.post('api/access-token-refresh/',{ withCredentials: true });
                return custom_api_func(originalRequest); // Retry original request
            } catch (refreshError) {
                console.log('xxx', 'here 2');
                console.log('Refresh token failed', refreshError);
                logout();
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

function logout() {
    custom_api_func.get('api/logout/');
    localStorage.clear()
    window.location.href = '/';
}

export default custom_api_func;